import collectionApiClient from '../../../api/collections';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const useSendCollectionToClockMutation = (
  options?: UseKlydoMutationOptions<void, { collectionId: string }>,
) => {
  return useKlydoMutation({
    mutationKey: ['send-collection-to-clock'],
    mutationFn: ({ collectionId }) =>
      collectionApiClient.sendCollectionToClock(collectionId),
    ...options,
  });
};

export default useSendCollectionToClockMutation;
